import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';

const slideSettings = {
  centerMode: true,
  centerPadding: '0px',
  autoplay: true,
  slidesToShow: 1,
  variableWidth: true,
  arrows: true,
  dots: false,
  speed: 500,
  infinite: true,
  autoplaySpeed: 15000,
  slidesToScroll: 1,
  initialSlide: 0,
};

const HomeHero = () => (
  <StaticQuery
    query={graphql`
      query {
        JulyCover: file(relativePath: { eq: "top-slider/july.png" }) {
          childImageSharp {
            fluid(maxWidth: 800, maxHeight: 350, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        DenmarkCover: file(relativePath: { eq: "top-slider/denmark_2.png" }) {
          childImageSharp {
            fluid(maxWidth: 800, maxHeight: 350, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        Denmark3Cover: file(relativePath: { eq: "top-slider/denmark_3.png" }) {
          childImageSharp {
            fluid(maxWidth: 800, maxHeight: 350, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={(data) => {
      const list = [
        {
          cover: `JulyCover`,
          href: `https://www.clarity.tokyo/articles/daibasitei/denmark-series-1/`,
          title: `【特別連載・第一弾】前例が無ければ自分から始めればいい。男女不平等の時代から女性のキャリアを確立してきた先輩に聞く、自分らしい生き方を選ぶ方法`,
          company_name: ``,
        },
        {
          cover: `DenmarkCover`,
          href: `https://www.clarity.tokyo/articles/daibasitei/denmark-series-2/`,
          title: `男性だって時短は当たり前！環境の変化を楽しんだ日本人父に聞く、皆をハッピーにする男女平等子育て社会のリアル`,
          company_name: ``,
        },

        {
          cover: `Denmark3Cover`,
          href: `https://www.clarity.tokyo/articles/interview/denmark-series-3/`,
          title: `個性は最大の強みになる。デンマーク人起業家・彩さんに聞く、デンマーク流の起業・男女差・働き方と、日本人への示唆`,
          company_name: ``,
        },
      ];
      return (
        <div className="container-fluid px-0">
          <div className="home-slider w-100 mt-header">
            <Slider {...slideSettings}>
              {list.map((article, index) => (
                <div key={index}>
                  <div className="home-slider-article">
                    <a href={article.href}>
                      <div className="home-slider-article-visual">
                        <Img
                          fluid={data[article.cover].childImageSharp.fluid}
                        />
                      </div>

                      <div className="home-slider-article-meta">
                        <p className="home-slider-article-meta-title">
                          {article.title}
                        </p>
                        <p className="home-slider-article-meta-company-name">
                          {article.company_name || '-'}
                        </p>
                      </div>
                    </a>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      );
    }}
  />
);

export default HomeHero;
